import { IconLib } from 'components/Atoms/IconLib'
import styled, { css } from 'styled-components'

const designerCSS = css`
  .overlay {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .overlay button#btnPad {
    font-weight: 600;
    font-size: 1rem;
    border-radius: 10px;
    padding: 12px 24px;
    background: hsla(0, 0%, 100%, 0.2);
  }

  .overlay button {
    margin: 20px 0 0 0;
    padding: 8px 18px;
  }
`

const developerCSS = css``

export const HiLoNoBalanceCSS = styled.div`
  ${designerCSS}
  ${developerCSS}
`

export const Close = styled(IconLib).attrs({ collection: 'general', name: 'closeOutline', dimension: '25px' })`
  position: absolute;
  left: 10px;
  top: 10px;
  background: rgba(255, 255, 255, 1);
  :hover {
    cursor: pointer;
  }
`
